import { useContext, useEffect, useState } from "react";
import { SurveyRespondentDataContext } from "../../providers/survey-respondent-data";

import CustomModal from "../custom-modal";
import IdentificationModalForm from "./form";
import IdentificationModalInvalidInput from "./invalid-input";

const IdentificationModal = () => {
  const { submitNewRespondent, requiresPassword } = useContext(SurveyRespondentDataContext);

  const [previousSubmittedRespondentId, setPreviousSubmittedRespondentId] = useState();
  const [wasValidated, setWasValidated] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [error, setError] = useState();

  useEffect(() => {
    // El modal solo estará visible cuando el usuario haya pasado la validación en handleSubmit(),
    // representado con una variable 'error' sin datos.
    if (!wasValidated) {
      setIsVisible(true);
    } else {
      if (isValidating || (error && !isValidating)) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }
  }, [wasValidated, error, isValidating]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const respondentId = event.target[0].value;
    const password = requiresPassword ? event.target[1].value : "";

    // Para evitar la sobrecarga de peticiones fetch, solo se permite enviar (hacer submit) el mismo respondent id una sola vez, esto obligará
    // al usuario a ingresar un valor diferente para volver a hacer la solicitud a la API.
    // (Solo aplicable en encuestas que no pidan contraseña)
    if (!requiresPassword && previousSubmittedRespondentId === respondentId) {
      return;
    }

    setIsValidating(true);
    setError();

    const error = await submitNewRespondent(respondentId, password);
    if (error) {
      setError(error);
    }

    setPreviousSubmittedRespondentId(respondentId);
    setWasValidated(true);
    setIsValidating(false);
  };

  return (
    <CustomModal
      id="identification-modal"
      headerTitle="Antes de ingresar"
      isVisible={isVisible}
      preventCloseOnClickOutside
    >
      <IdentificationModalForm
        handleSubmit={handleSubmit}
        isValidating={isValidating}
        invalidInputComponent={
          <IdentificationModalInvalidInput wasValidated={wasValidated} error={error} />
        }
      />
    </CustomModal>
  );
};

export default IdentificationModal;
